var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.352 13.178l-2.813-2.812-2.812 2.812M2.258 12.475l.007-2.109c.009-.268.05-.533.12-.791M4.18 7.292a4.907 4.907 0 012.64-.442M9.699 7.414a3.656 3.656 0 011.568 2.136M11.398 12.524v2.714M12.16 18.054a3.738 3.738 0 002.26 1.388M17.398 19.473a3.541 3.541 0 002.317-1.285M20.54 15.387v-5.021",
    stroke: "#FF3C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgProgress;